/// <reference path="../../_ext/Bases/GridBase.ts" />
namespace TabAurous.OMS {

    import fld = DesignRow.Fields;
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.filterable()
    export class DesignGrid extends _Ext.GridBase<DesignRow, any> {
        protected getColumnsKey() { return 'OMS.Design'; }
        protected getDialogType() { return <any>DesignDialog; }
        protected getIdProperty() { return DesignRow.idProperty; }
        protected getLocalTextPrefix() { return DesignRow.localTextPrefix; }
        protected getService() { return DesignService.baseUrl; }
        protected getInsertPermission() { return DesignRow.insertPermission; }
        protected getUpdatePermission() { return DesignRow.updatePermission; }
        protected getDeletePermission() { return DesignRow.deletePermission; }
        protected get_ExtGridOptions() { return Q.deepClone(q.DefaultMainGridOptions) }
        protected useViewMode() { return true; }
        //public initDialog(dialog: DesignDialog) {
        //    super.initDialog(dialog);
        //    dialog.parentGrid = this;
        //}
        constructor(container: JQuery,options) {
            super(container,options);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            

            this.slickGrid.setOptions({ rowHeight: 30 });

            return this;
        }
        private autoSize;

        

        //protected editItem(entityOrId) {
        //    var id = parseInt(entityOrId);

        //    if (id > 0) {
        //        var dlg = new DesignDialog({
        //            grid: this, showNextPreviousButtons: true, entityOrId: entityOrId

        //        });
        //        dlg.loadByIdAndOpenDialog(entityOrId);
        //    }
        //    else {
        //        var dlg = new DesignDialog({
        //            grid: this, showNextPreviousButtons: false

        //        });
        //        dlg.loadNewAndOpenDialog();
        //    }

        //}

        ////protected onViewSubmit() {
        ////     only continue if base class returns true (didn't cancel request)
        ////    if (!super.onViewSubmit()) {
        ////        return false;
        ////    }

        ////     view object is the data source for grid (SlickRemoteView)
        ////     this is an EntityGrid so its Params object is a ListRequest
        ////    var request = this.view.params as Serenity.ListRequest;

        ////     list request has a Criteria parameter
        ////     we AND criteria here to existing one because 
        ////     otherwise we might clear filter set by 
        ////     an edit filter dialog if any.

        ////    request.Criteria = Serenity.Criteria.and(request.Criteria,
        ////        [['TypeName'], '!=', 'Pendant'],
        ////        [['SubCategoryName'], '!=', 'Jhumka']);
        ////        [['Discontinued'], '=', 0]);

        ////     TypeScript doesn't support operator overloading
        ////     so we had to use array syntax above to build criteria.

        ////     Make sure you write
        ////     [['Field'], '>', 10] (which means field A is greater than 10)
        ////     not 
        ////     ['A', '>', 10] (which means string 'A' is greater than 10

        ////    return true;
        ////}

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); // *** If you want to make it autoresize when grid is loaded, use: new Slick.AutoColumnSize(true);
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady(); 
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                /*if (target.hasClass('print-invoice')) {
                    Admin.Common.ReportHelper.execute({
                        reportKey: 'Northwind.OrderDetail',
                        params: {
                            OrderID: item.OrderID
                        }
                    });
                }*/
            }
        }
        // Excel Import
        protected getButtons(): Serenity.ToolButton[] {

            // call base method to get list of buttons
            var buttons = super.getButtons();

            //// add our import button
            //buttons.push({
            //    title: 'Import',
            //    cssClass: 'import-xlsx-button',
            //    onClick: () => {
            //        // open import dialog, let it handle rest
            //        var dialog = new DesignExcelDialog();
            //        dialog.element.on('dialogclose', () => {
            //            this.refresh();
            //            dialog = null;
            //        });
            //        dialog.dialogOpen();
            //    }
            //}); 
            //buttons.push({
            //    title: 'Perform Rate Update',
            //    cssClass: 'send-button',
            //    onClick: () => {
            //        if (!this.onViewSubmit()) {
            //            return;
            //        }

            //        var action = new Common.OrderBulkAction();
            //        action.done = () => this.rowSelection.resetCheckedAndRefresh();
            //        action.execute(this.view.getItems().map(x => x.DesignId.toString()));
            //    }
            //})
            return buttons;
        }

        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
                this.toolbar.findButton('import-xlsx-button').toggle(this.updateDisabledState());

            }
        }
        
    }
}